import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LETTER_TEMPLATE_CONTROLLER } from "api/Service";

export const useLetterTemplatesAll = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["letterTemplatesAll", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${LETTER_TEMPLATE_CONTROLLER}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
  });
};
